import React, { useEffect, useState } from "react";
import { Route } from "react-router-dom";
import { FINAL_COMMENTS_ROUTES } from "../../../app/router/routes";
import LoaderComponent from "../../../components/Loader/LoaderComponent";
import NavBar from "../../../components/navbar/NavBar";
import { SectionColumn } from "../../../components/section";
import { createStepper, disableAlert, STEPPER_STATUS } from "../../../components/stepper/dynamicStepper";
import { DASHBOARD_ICONS } from "../../../Helpers/ICONS";
import ImporterStep1 from "../../importer/review/flow/ImporterStep1";
import ImporterStep4 from "../../importer/review/flow/ImporterStep4";
import ImporterStep5 from "../../importer/review/flow/ImporterStep5";
import ImporterStep6 from "../../importer/review/flow/ImporterStep6";
import ImporterStep7 from "../../importer/review/flow/ImporterStep7";

export const stepperName = "FCView";

const FinalImporterView = () => {
    const stepper = [
        {
            step: "Business Details",
            status: STEPPER_STATUS.COMPLETED,
        },
        {
            step: "Previous Product Details",
            status: STEPPER_STATUS.COMPLETED,
        },

        {
            step: "Current Product Details",
            status: STEPPER_STATUS.COMPLETED,
        },

        {
            step: "Certificates",
            status: STEPPER_STATUS.COMPLETED,
        },
        { step: "Other Documents", status: STEPPER_STATUS.COMPLETED },
    ];
    const [stepperData, setStepperData] = useState();
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        setStepperData(createStepper(stepperName, stepper));
        disableAlert();
        setTimeout(() => {
            setIsLoading(false);
        }, 1000);
    }, []);

    const routeArray = [
        FINAL_COMMENTS_ROUTES.IMSTEP01,
        FINAL_COMMENTS_ROUTES.IMSTEP02,
        FINAL_COMMENTS_ROUTES.IMSTEP03,
        FINAL_COMMENTS_ROUTES.IMSTEP04,
        FINAL_COMMENTS_ROUTES.IMSTEP05,
    ];
    return (
        <div>
            <LoaderComponent isOpen={isLoading} />
            <NavBar
                stepperName={stepperName}
                title={"Final Comments Application Review"}
                tableIcon={DASHBOARD_ICONS.finalComments}
                tableURL={FINAL_COMMENTS_ROUTES.REVIEW}
            />

            {stepperData && (
                <SectionColumn className='w-full pt-1'>
                    <Route path={FINAL_COMMENTS_ROUTES.IMSTEP01}>
                        <ImporterStep1
                            stepperData={stepperData}
                            stepperName={stepperName}
                            routeArray={routeArray}
                            setIsLoading={setIsLoading}
                            customIndex={0}
                            nextCustomRoute={FINAL_COMMENTS_ROUTES.IMSTEP02}
                            readOnly
                            hideFiles={true}
                        />
                    </Route>

                    <Route path={FINAL_COMMENTS_ROUTES.IMSTEP02}>
                        <ImporterStep4
                            stepperData={stepperData}
                            stepperName={stepperName}
                            routeArray={routeArray}
                            setIsLoading={setIsLoading}
                            customIndex={1}
                            nextCustomRoute={FINAL_COMMENTS_ROUTES.IMSTEP03}
                            readOnly
                        />
                    </Route>
                    <Route path={FINAL_COMMENTS_ROUTES.IMSTEP03}>
                        <ImporterStep5
                            stepperData={stepperData}
                            stepperName={stepperName}
                            routeArray={routeArray}
                            setIsLoading={setIsLoading}
                            customIndex={2}
                            nextCustomRoute={FINAL_COMMENTS_ROUTES.IMSTEP04}
                            readOnly
                        />
                    </Route>
                    <Route path={FINAL_COMMENTS_ROUTES.IMSTEP04}>
                        <ImporterStep6
                            stepperData={stepperData}
                            stepperName={stepperName}
                            routeArray={routeArray}
                            setIsLoading={setIsLoading}
                            customIndex={2}
                            nextCustomRoute={FINAL_COMMENTS_ROUTES.IMSTEP05}
                            readOnly
                        />
                    </Route>
                    <Route path={FINAL_COMMENTS_ROUTES.IMSTEP05}>
                        <ImporterStep7
                            stepperData={stepperData}
                            stepperName={stepperName}
                            routeArray={routeArray}
                            setIsLoading={setIsLoading}
                            customIndex={2}
                            nextCustomRoute={FINAL_COMMENTS_ROUTES.REVIEW}
                            readOnly
                        />
                    </Route>
                </SectionColumn>
            )}
        </div>
    );
};

export default FinalImporterView;